import React from 'react';
import {useSuspenseQuery} from '@tanstack/react-query';
import {getQueryKey} from '@shared/queryKeyMap';
import {diApi} from '@di-shared/api/di';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {CreatedMaintenanceRecordRequest} from '@di-shared/api/di/__generated';

interface SestExchangeInfoTitleProps {
  sestCodes: CreatedMaintenanceRecordRequest.sestCode[];
}

function SestExchangeRegisterInfoTitle({sestCodes}: SestExchangeInfoTitleProps): JSX.Element {
  const {t} = useInferableTranslation();
  const {data: sestData} = useSuspenseQuery({
    queryKey: [getQueryKey(diApi.maintenancesSestController.getSestItems)],
    queryFn: () => diApi.maintenancesSestController.getSestItems1(),
    select: (data) => data.data,
  });
  const sestNames = sestData
    ?.filter((sest) => sestCodes?.includes(sest.code as CreatedMaintenanceRecordRequest.sestCode))
    .map((sest) => sest.name);

  return (
    <div className="section_heading type_main">
      <h2 className="section_heading_title">
        {sestNames[0]}
        {sestNames?.length > 1 ? ' ' + t('T30157_$count', {count: sestNames?.length - 1}) : ''}
      </h2>
      <p
        className="section_heading_desc"
        style={{whiteSpace: 'pre-wrap'}}
      >
        {t('T30156')}
      </p>
    </div>
  );
}

export default SestExchangeRegisterInfoTitle;

export function SestExchangeRegisterInfoTitleLoading() {
  return (
    <div className="section_heading type_main">
      <h2
        className="section_heading_title skeleton"
        style={{height: 30}}
      />
      <p
        className="section_heading_desc skeleton"
        style={{height: 54}}
      />
    </div>
  );
}
